<template>
  <HomeLay>
    <div slot-scope="scope" class="me-body" :style="{ 'min-height': scope.data.height + 'px' }">
      <div class="margin-body">
        <div class="position">
          <p class="po-sty">位置</p>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">商城</el-breadcrumb-item>
            <el-breadcrumb-item><span class="ac-span">{{ title }}</span></el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="my-style">
          <div class="left-menus">
            <div v-for="(item,index) in menus" :key="index">
              <p class="y-name">{{ item.name }}</p>
              <ul>
                <li v-for="(li,jndex) in item.list" :key="jndex" @click="turnTo(li)">
                  <span><img :src="li.icon"></span><span class="menu-name">{{ li.name }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="my-contents">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </HomeLay>
</template>

<script>
import HomeLay from '@/views/HomeLay/HomeLay.vue';

export default {
  components: {
    HomeLay
  },
  data() {
    return {
      title: '',
      NeedId: '',
      url: {
        GetCustomAuthType: SZH.assets.api + '/Custom/GetCustomAuthType',
        GetCompanyListInfo: SZH.assets.api + '/Custom/GetCompanyListInfo',
      },
      menus: [
        {
          name: '账户',
          list: [
            {
              name: '账户信息',
              url: '/My/userInfo',
              // url:'/My/Set',
              active: false,
              icon: '/static/images/HomeTH/usericon.png'
            },
            {
              name: '我的会员',
              url: '/My/myMember',
              active: false,
              icon: '/static/images/HomeTH/membericon.png'
            },
            {
              name: '供应商认证',
              url: '/My/SupplierCertification',
              active: false,
              icon: '/static/images/HomeTH/membericon.png'
            },
            {
              name: '我的银行卡',
              url: '/My/BankCard',
              active: false,
              icon: '/static/images/HomeTH/bankicon.png'
            },
            {
              name: '常用车辆管理',
              url: '/My/Cars',
              active: false,
              icon: '/static/images/HomeTH/car.png'
            },
            {
              name: '危化品登记',
              url: '/My/HazardousChemicalsEntry',
              active: false,
              icon: '/static/images/HomeTH/car.png'
            }
          ]
        },
        {
          name: '订单',
          list: [
            {
              name: '我的订单',
              url: '/My/OrderList',
              active: false,
              icon: '/static/images/HomeTH/ordericon.png'
            },
            {
              name: '我的提货单',
              url: '/My/OrderLading',
              active: false,
              icon: '/static/images/HomeTH/ladingicon.png'
            },
            {
              name: '我参与的招标',
              url: '/My/MyBidding',
              active: false,
              icon: '/static/images/HomeTH/ladingicon.png'
            }
          ]
        },
        // {
        //   name:'资产',
        //   list:[
        //     {
        //       name:'我的余额',
        //       url:'',
        //       active:false,
        //       icon:'/static/images/HomeTH/chareicon.png'
        //     }
        //   ]
        // }
      ]
    }
  },
  methods: {
    //新需求  企业认证与易购认证 只能进行认证一个
    GetCustomAuthType() {
      let self = this
      self.$http.post(self.url.GetCustomAuthType, {}).then(result => {
        if (result.state == true) {
            //未进行认证
            if (result.data == "-1") {
              self.$router.push({
                path: '/My/myMember'
              })
            } else if (result.data == "0") {
              //已进行易购认证
              self.$router.push({
                path: '/My/EgQualifications'
              })
            } else if (result.data == "1") {
              // 已进行企业认证
              self.$http.post(self.url.GetCompanyListInfo, {}).then(result => {
                if (result.state == true && result.data) {
                  self.$router.push({
                    path: '/My/CompanyAuthen',
                    query: {
                      Id: result.data[0].Id
                    }
                  })
                }
              })
            } else {
              self.$message.error("网络错误，请联系管理员")

            }
          }
        }
      )
    },

    turnTo(li) {
      if (li.url == '/My/myMember') {
        this.GetCustomAuthType()
      } else {
        this.$router.push({
          path: li.url
        })
      }
    }
    ,
  },
  computed: {}
  ,
  mounted() {
    this.title = this.$route.meta.name;
  }
  ,
  watch: {
    '$route.meta.name'() {
      this.title = this.$route.meta.name;
    }
  }

}
</script>

<style scoped>
.me-body {
  background: #f5f5f5;
}

.position {
  padding: 20px 0px;
  display: flex;
  align-items: center;
}

.po-sty {
  font-size: 18px;
  font-weight: 600;
  margin-right: 50px;
  margin-left: 10px;
}

.margin-body {
  width: 1300px;
  margin: 0px auto;
}

.my-style {
  display: flex;
}

.left-menus {
  width: 285px;
  /*min-height: 500px;*/
  background: #fff;
  padding: 30px 20px;
  max-height: 600px;
}

.left-menus ul {
  margin-top: 15px;
}

.left-menus ul li {
  display: flex;
  align-items: center;
  margin: 20px 0px;
  cursor: pointer;
}

.left-menus ul li .menu-name {
  font-size: 14px;
  color: #666666;
  margin-left: 10px;
}

.my-contents {
  flex: 1;
  background: #fff;
  margin-left: 20px;
  /*height: 700px;*/
  padding: 20px;
}

.y-name {
  color: #666666;
  font-size: 14px;
}

.ac-span {
  color: #0441A0;
}
</style>



// WEBPACK FOOTER //
// src/views/Me/LayOutTH/LayOutTH.vue